import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { Authentication } from '@leedpulse-monorepo/classes';

interface CancelScheduledPlanChangeResponse {
  subscription_id: string;
  cancelled_plan_id: string;
}

/** Drop a plan change scheduled for a later day. Nothing had moved on Stripe yet. */
async function cancelScheduledPlanChange(
  subscriptionId: string,
  auth: Authentication
): Promise<CancelScheduledPlanChangeResponse> {
  try {
    const response = await HttpClient.post(
      '/leedflow/stripe/backoffice/cancel-scheduled-plan-change',
      { subscription_id: subscriptionId },
      auth.token
    );
    return response.data;
  } catch (e: any) {
    console.error('cancelScheduledPlanChange error:', e);
    throw new CancelScheduledPlanChangeFailure(e.message);
  }
}

export class CancelScheduledPlanChangeFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default cancelScheduledPlanChange;